<div class="not-ready-header-container">
  <glxy-empty-state class="not-ready-state-container">
    <glxy-empty-state-hero>
      <mat-icon>schedule</mat-icon>
    </glxy-empty-state-hero>
    <glxy-empty-state-title class="not-ready-title">
      {{ 'EMPTY_STATE.NOT_READY.TITLE' | translate }}
    </glxy-empty-state-title>
    <p
      class="not-ready-description"
      [innerHTML]="
        'EMPTY_STATE.NOT_READY.DESCRIPTION'
          | translate: { snapshotName: snapshotName }
      "
    ></p>
  </glxy-empty-state>
</div>
